/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_Started_AllInputs */

const en_follow_started_all = /** @type {(inputs: Follow_Started_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following: every change, not only its status, reaches your notifications.`)
};

/**
* | output |
* | --- |
* | "Following: every change, not only its status, reaches your notifications." |
*
* @param {Follow_Started_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const follow_started_all = /** @type {((inputs?: Follow_Started_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_Started_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_follow_started_all(inputs)
});